import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import './NavBar.css';

const Button = ({ id, defaultMessage, activeFilter, updateFilter }) => {
    const [ isActive, setIsActive ] = useState(false);
    useEffect(() => {
        id === activeFilter ? setIsActive (true) : setIsActive(false);
    },  [activeFilter]);

    return (
        <button 
            className={isActive ? 'navbar-btn nb-active' : 'navbar-btn'}
            onClick={() => updateFilter(id)}
        >
            <FormattedMessage
                id={id}
                defaultMessage=' '
            />
        </button>
    )
}

const NavBar = ({ activeFilter, updateFilter }) => {
    return (
        <div className='navbar'>
            <Button id='categories' defaultMessage='' activeFilter={activeFilter} updateFilter={updateFilter}/>
            <Button id='collections' defaultMessage='' activeFilter={activeFilter} updateFilter={updateFilter}/>
        </div>
    )
};

export default NavBar;